var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.productId)?_c('div',{staticClass:"product-chart"},[(!_vm.isLoading)?_c('apexchart',{attrs:{"width":_vm.width,"height":_vm.height,"type":_vm.chartType,"options":_vm.chartOptions,"series":_vm.series}}):_vm._e(),_vm._v(" "),(_vm.isLoading)?_c('div',{staticClass:"loader-container"},[_c('span',{staticClass:"loader"})]):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }